// Çarkıfelek gizleme scripti
(() => {
  const ICON_ID = 'crazyrocket-launch-icon';
  const HIDE_CLASS = 'hidden';
  const SESSION_KEY = 'crazyrocket-hidden';

  const getIcon = () => document.getElementById(ICON_ID);
  const hideIcon = () => { const el = getIcon(); if (el) el.classList.add(HIDE_CLASS); };

  // Explicit account check (path + query + hash)
  const isAccountPage = () => {
    const p = location.pathname;
    const extra = location.search + location.hash;
    return /(\/|^)account(\/|$)/i.test(p) || /\baccount\b/i.test(extra);
  };

  // Always run: hide on account pages, no session flag
  const applyAccountRule = () => { if (isAccountPage()) hideIcon(); };

  // Original behavior: if already hidden this session, hide; else hide after 60s and set flag
  const applySessionRule = () => {
    if (sessionStorage.getItem(SESSION_KEY)) {
      hideIcon();
    } else {
      setTimeout(() => {
        const el = getIcon();
        if (el) {
          el.classList.add(HIDE_CLASS);
          sessionStorage.setItem(SESSION_KEY, 'true');
        }
      }, 60000);
    }
  };

  const init = () => {
    applySessionRule();  // 1-minute auto-hide always on
    applyAccountRule();  // explicit hide on account pages
  };

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Handle SPA navigations
  const onRouteChange = () => applyAccountRule();
  window.addEventListener('popstate', onRouteChange);
  window.addEventListener('hashchange', onRouteChange);
  ['pushState','replaceState'].forEach(fn => {
    const orig = history[fn];
    history[fn] = function () { const r = orig.apply(this, arguments); window.dispatchEvent(new Event('pushstate')); return r; };
  });
  window.addEventListener('pushstate', onRouteChange);
})();
